import { Loader2 } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { Field } from "../components/site/Field";
import { FormSuccess } from "../components/site/FormSuccess";
import { Eyebrow, Reveal } from "../components/site/motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useSubmitForm } from "../hooks/useForm";

const INITIAL = { name: "", email: "", subject: "", message: "" };
const FAQ = [
  { q: "When can I buy DanoBars?", a: "We're finalizing recipes now. Join the launch list and we'll email you when bars are ready to order." },
  { q: "What's in the bars?", a: "Real, recognizable ingredients. Each 100g bar has approximately 25g of protein. Full ingredient lists and nutrition facts are coming soon." },
  { q: "Can I order now?", a: "Not yet. Vanilla Almond and Chocolate are coming soon. Tap 'Notify me at launch' on either bar's page and we'll email you when they're available." },
];

export default function Contact() {
  const { bind, submit, loading, done, setDone } = useSubmitForm("/contact", INITIAL, "Message sent. Thanks!");
  return (
    <div data-testid="contact-page">
      <PageHero testId="contact-hero" eyebrow="Contact" lines={["Say", "hello."]} intro="Questions, ideas, or just want to talk bars? Send us a note." />
      <section className="mx-auto grid max-w-[1440px] gap-12 px-5 sm:px-8 lg:grid-cols-12 lg:px-12 pb-24 sm:pb-32">
        <div className="lg:col-span-7">
          {done ? (
            <FormSuccess testId="contact-success" title="Message received." text="Thanks for reaching out. We'll reply by email." onReset={() => setDone(false)} />
          ) : (
            <Reveal>
              <form onSubmit={submit} data-testid="contact-form" className="grid gap-5 rounded-[28px] bg-dano-sand/70 p-6 sm:grid-cols-2 sm:p-10">
                <Field label="Name" required testId="contact-name-input" {...bind("name")} />
                <Field label="Email" type="email" required testId="contact-email-input" {...bind("email")} />
                <Field label="Subject" testId="contact-subject-input" className="sm:col-span-2" {...bind("subject")} />
                <Field label="Message" textarea required testId="contact-message-input" className="sm:col-span-2" {...bind("message")} />
                <button type="submit" disabled={loading} data-testid="contact-form-submit" className="btn-press sm:col-span-2 inline-flex items-center justify-center gap-2 rounded-full bg-dano-ink py-4 font-cond text-lg uppercase tracking-widest text-dano-cream hover:bg-dano-red disabled:opacity-70">
                  {loading && <Loader2 className="h-5 w-5 animate-spin" />} Send message
                </button>
              </form>
            </Reveal>
          )}
        </div>
        <div className="lg:col-span-4 lg:col-start-9">
          <Reveal><Eyebrow>Quick answers</Eyebrow></Reveal>
          <Accordion type="single" collapsible className="mt-4" data-testid="contact-faq">
            {FAQ.map((f, i) => (
              <AccordionItem key={f.q} value={`f${i}`} className="border-b-2 border-dano-ink">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-wide text-lg uppercase hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="text-base text-dano-ink/80">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
